import React, { FunctionComponent, useState } from 'react';
import negativeUserImg from '../../assets/images/negativeUserImg.svg';
import positiveUserImg from '../../assets/images/positiveUserImg.svg';
import neutraUserImg from '../../assets/images/neutraUserImg.svg';
import styles from './UserInformation.module.scss';
import {
  Ellipse_one,
  ImportantIcon,
  UserImg,
  VerifiedIcon,
} from 'app/assets/images/icons';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';
interface Props {
  isClickable?: boolean;
  profileImage: string;
  name?: string;
  username?: string;
  isVerified?: boolean;
  isUserAdded?: boolean;
  handleInfluencerOrEntity?: () => void;
  openModalToAddInfluencer?: () => void;
  postType?: 'negative' | 'positive' | 'neutral' | 'all';
  isSmallerSize?: boolean;
  hideAtIcon?: boolean;
  audio_owner_name?: string;
  audio_name?: string;
  time?: string;
  bio?: string;
  withSubscriberCount?: boolean;
  subscriberCount?: number;
}
const postTypeImg = {
  negative: negativeUserImg,
  positive: positiveUserImg,
  neutral: neutraUserImg,
  all: '',
};
const UserInformation: FunctionComponent<Props> = ({
  isClickable,
  name,
  profileImage,
  username,
  isUserAdded,
  isVerified,
  handleInfluencerOrEntity,
  openModalToAddInfluencer,
  isSmallerSize,
  postType,
  hideAtIcon,
  audio_name,
  audio_owner_name,
  time,
  bio,
  withSubscriberCount,
  subscriberCount,
}) => {
  const [isImageLoaded, setIsImageLoaded] = useState(true);
  return (
    <section
      className={`${isClickable && isUserAdded ? 'cursor-pointer' : ''} ${styles.UserInformation}`}
      data-testid="handelInfluencer-test"
      onClick={() => {
        isClickable && isUserAdded ? handleInfluencerOrEntity?.() : undefined;
      }}
    >
      <div
        className={`${isSmallerSize ? styles.userImgSmallerSize : styles.userImg}`}
      >
        {profileImage && isImageLoaded ? (
          <div>
            <img
              src={profileImage}
              alt="image"
              onError={() => setIsImageLoaded?.(false)}
            />
          </div>
        ) : profileImage !== '' && !isImageLoaded ? (
          <ImportantIcon style={{ width: 48, height: 48 }} />
        ) : postType && postType !== 'all' ? (
          <div>
            <img src={postTypeImg[postType]} alt="image" />
          </div>
        ) : (
          <UserImg
            width={!isSmallerSize ? '48px' : '35px'}
            height={!isSmallerSize ? '48px' : '35px'}
          />
        )}
      </div>
      <div
        data-testid="openModalToAddInfluencer-testid"
        className={`${styles.userName} ${isClickable && !isUserAdded ? 'cursor-pointer' : ''}`}
        onClick={() =>
          !isUserAdded && isClickable && openModalToAddInfluencer?.()
        }
      >
        {name && (
          <span className={username === undefined ? 'post_card_username' : ''}>
            {name}{' '}
            {isVerified && (
              <span>
                <VerifiedIcon />
              </span>
            )}
          </span>
        )}
        {username && (
          <span className="post_card_username">
            {!hideAtIcon ? '@' + username : username}
          </span>
        )}
        {audio_owner_name && (
          <span className={styles.audioSection}>
            {audio_owner_name} <Ellipse_one />
            {audio_name}
          </span>
        )}
        {withSubscriberCount && (
          <span>{`${nFormatter(subscriberCount)} ${_t('posts:subscribers')}`}</span>
        )}
        <span>{time}</span>
        {bio && <span className={styles.bio}>{bio}</span>}
      </div>
    </section>
  );
};

export default UserInformation;
